import { pxToRem } from 'styles/functions'

const theme = {
  logo_height: 100,

  token_hidden: true,
  number_hidden: true,

  button_radius: 20,
  button_font: `'Aeonik', sans-serif`,
  button_text_size: 17,
  button_text_lineheight: 24,
  button_text_weight: 400,
  button_padding: `${pxToRem(14.5)}`,

  button_half_text_weight: 500,
  button_half_border_color: 'white',

  text_font: `'Aeonik', Arial, sans-serif`,
  text_size: 16,
  text_lineheight: 20,

  title_font: `'Aeonik', Arial, sans-serif`,
  title_weight: 500,
  title_size: 45,
  title_lineheight: 45,
  title_margin: `${pxToRem(10)} 0 ${pxToRem(10)} ${pxToRem(10)}`,

  subtitle_size: 28,
  subtitle_weight: 500,
  subtitle_lineheight: 32,

  audio_background_color: '#107285',

  separator_color: 'black',
}

export const lcda = {
  ...theme,
  logo_image_url: 'lcda.png',
  body_background_color: 'black',
  button_color: '#434242',
}

export const lcda_trajectoires = {
  ...theme,
  token_hidden: true,

  logo_image_url: 'lcda3.png',
  header_full_height: true,

  body_background_color: '#0066b3',
  button_color: '#4db748',
  button_border_radius: 10,
  button_border_width: 2,
}

export const lcda_realisations = {
  ...theme,
  logo_image_url: 'lcda2.png',
  body_background_color: '#d6b586',
  header_border_color: '#434242',

  button_color: '#f0f16c',
  button_text_color: 'black',
  button_hover_text_color: 'black',
  button_outlined_text_color: 'balck',
  button_outlined_hover_text_color: 'black',

  footer_border_color: '#434242',
}

export const lcda_festival = {
  //LCDA – FHOSQ
  ...theme,
  logo_image_url: 'lcda_festival.jpg',
  logo_height: 230,

  body_background_color: '#f2f2f2',
  button_color: '#F2A950',
  
  button_radius: 100,
  button_border_width: 2,
  
  title_font: `DMSerifText`,
  text_font: `'DMSerifText', sans-serif`,
  button_font: `'DMSerifText', sans-serif`,
}